import React, { memo, useState } from "react";
import { Button } from "ui/components/Button/Button";
import FileUploadModal from "ui/components/FileUpload/FileUploadModal/FileUploadModal";
import FileUploadList from "ui/components/FileUpload/FileUploadList/FileUploadList";
import { FileUploadControlProps } from "./types";

const FileUploadControl: React.FC<FileUploadControlProps> = ({
  uploads,
  onUploadSave,
  onUploadDelete,
  buttonText = "Dodaj datoteke",
  modalTitle = "Upload datoteka",
  maxFiles,
  showNameField,
  showDescriptionField,
  nameLabel,
  namePlaceholder,
  descriptionLabel,
  descriptionPlaceholder,
  emptyText,
}) => {
  const [showModal, setShowModal] = useState(false);

  const isMaxReached = maxFiles ? uploads.length >= maxFiles : false;

  return (
    <div>
      {!isMaxReached && (
        <Button
          variant="outlined"
          size="small"
          startIcon="/media/icons/plus.svg"
          onClick={() => setShowModal(true)}
        >
          {buttonText}
        </Button>
      )}

      {uploads.length > 0 ? (
        <div className="mt-3">
          <FileUploadList files={uploads} onDelete={onUploadDelete} />
        </div>
      ) : emptyText ? (
        <div
          className="mt-3 border-2 border-dashed border-slate-300 rounded-sm p-6 text-center text-sm text-slate-400 cursor-pointer hover:border-blue-400 hover:text-blue-500 transition-colors"
          onClick={() => setShowModal(true)}
        >
          {emptyText}
        </div>
      ) : null}

      <FileUploadModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSave={onUploadSave}
        title={modalTitle}
        maxFiles={maxFiles}
        showNameField={showNameField}
        showDescriptionField={showDescriptionField}
        nameLabel={nameLabel}
        namePlaceholder={namePlaceholder}
        descriptionLabel={descriptionLabel}
        descriptionPlaceholder={descriptionPlaceholder}
      />
    </div>
  );
};

export default memo(FileUploadControl);
